 
import { createSlice } from '@reduxjs/toolkit';
import {
  UsersFiltersSetSearchAction,
  UsersFiltersState,
  UsersFiltersToggleActiveFiltersAction,
  UsersFiltersToggleSelectedFiltersAction,
} from './usersFilters.types';
import { createSliceHook, makeActionCreator } from '../helpers';
import { UserStatusEnum } from '@dynamika-shared/types/status';
import { userRoles } from 'src/constants/rolesList';
import { RootState } from '../store';
import { toggleFilterState } from './toggleFilterState';

const initialState: UsersFiltersState = {
  error: undefined,
  selectedFilters: {
    role: [],
    enabled: [],
  },
  allFilters: {
    role: userRoles,
    status: Object.values(UserStatusEnum).map(status => ({
      label: status.charAt(0) + status.slice(1).toLowerCase(),
      value: status,
    })),
  },
  state: {
    role: {
      active: false,
      label: 'Role',
    },
    status: {
      active: false,
      label: 'Status',
    },
  },
  search: '',
};

const { act } = makeActionCreator<UsersFiltersState>();

export const usersFiltersSlice = createSlice({
  name: 'usersFilters',
  initialState,
  reducers: {
    toggleActiveFilters: (
      filterSliceState,
      action: UsersFiltersToggleActiveFiltersAction
    ) => toggleFilterState(filterSliceState, action.payload),
    toggleSelectedFilters: act<
      UsersFiltersToggleSelectedFiltersAction['payload']
    >(({ name, value }, { selectedFilters }) => ({
      selectedFilters: {
        ...selectedFilters,
        [name]: selectedFilters[name]?.includes(value) ? [] : [value],
      },
    })),
    setSearch: (state, action: UsersFiltersSetSearchAction) => {
      state.search = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { toggleActiveFilters, reset, setSearch } =
  usersFiltersSlice.actions;

export const actions = {
  ...usersFiltersSlice.actions,
};

export const useUsersFiltersSlice = createSliceHook(
  usersFiltersSlice.name,
  actions
);

export const selectUsersFiltersState = (root: RootState) => root.usersFilters;
